import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { pjesmarres } from '../../../components/common/common-functions/common-functions';
import { handleDownloadResponse } from '../../../components/common/common-functions/handle-response';
import getConfig from '../../../helpers/config';
import { IdEntity } from '../../../interfaces/common-interfaces';
import {
  PjesmarresProps,
  TrainingMaterialsProps,
  UploadDocument,
} from '../../../interfaces/documents';
import { getPrepareHeaders } from '../get-prepare-headers';
const { test } = getConfig();

export const dokumentTrajnimiApi = createApi({
  reducerPath: 'dokumentTrajnimiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['Dokument'],

  endpoints: builder => ({
    getTrainingMaterial: builder.query<Blob, IdEntity>({
      query: arg => {
        return {
          url: `/dokument-trajnimi/${arg.id}`,
          responseHandler: handleDownloadResponse,
          invalidatesTags: ['Dokument'],
        };
      },
    }),
    uploadTrainingMaterial: builder.mutation<number, UploadDocument>({
      query: ({ id, role, ...body }) => {
        return {
          url: `/dokument-trajnimi/${id}${role === pjesmarres ? '/per-trajnues' : ''}`,
          method: 'POST',
          body: body.body,
        };
      },
      invalidatesTags: ['Dokument'],
    }),
    deleteTrainingMaterial: builder.mutation<void, PjesmarresProps>({
      query: ({ id, isPjesmarres }) => ({
        url: `dokument-trajnimi/${id}${isPjesmarres ? '/per-trajnues' : ''}`,
        method: 'DELETE',
        responseHandler: handleDownloadResponse,
      }),
      invalidatesTags: ['Dokument'],
    }),
    getTrainingDocumentById: builder.query<TrainingMaterialsProps[], IdEntity>({
      query: args => {
        return {
          url: `/trajnimi/${args.id}/dokument`,
        };
      },
      providesTags: ['Dokument'],
    }),
  }),
});

export const {
  useLazyGetTrainingMaterialQuery,
  useUploadTrainingMaterialMutation,
  useDeleteTrainingMaterialMutation,
  useGetTrainingDocumentByIdQuery,
} = dokumentTrajnimiApi;
